import Exception from '../pages/exception';
import TotalCategory from '../pages/totalCategory';
import CategoryList from '../pages/categoryList';
import Achievement from '../pages/achievement';
import AudioArticleShare from '../pages/audioArticleShare'

export default [
  {
    path: '/', component: TotalCategory
  },
  {
    path: '/AudioArticleShare/:id', component: AudioArticleShare
  },
  {
    path: '/Achievement', component: Achievement
  },
  {
    path: '/TotalCategory', component: TotalCategory
  },
  {
    path: '/CategoryList', component: CategoryList
  },
  {
    path: '/Exception/:errorCode', component: Exception
  }
]
